export * from "./globalTeleport";

import {
  defineCustomElement,
  createApp,
  getCurrentInstance,
  useShadowRoot
} from "vue";
import { trimScopedCSS, isInArray } from "@zyzgroup/core-common";
import { useLoadLink } from "@zyzgroup/core-web";
// import { teleport } from "./globalTeleport";
import router from "./hooks/useVueRouter";

// import imagesrc from "@root/assets/images/picture.jpg";
// import imagesrc from "@/src/components/rate-xg/rate_xg_level_1.svg";
// const imagesrc = `${import.meta.env.YZ_IMAGE_PATH}/lb-robot.png`;
// const imagesrc = `/public/images/lb-robot.png`; // 以 publicDir = /lib/ 为相对路径 ; 推荐使用这个，使 server-client 与 core-vue 共用 /lib/public/ 文件夹
// const imagesrc = `/images/lb-robot.png`; // 以 publicDir = /lib/public 为相对路径

// 示例 /lib/server-client/webcomponent.html

import ResizeObserver from "./components/base/ResizeObserver.ce.vue";

import Icon from "./components/form/Icon.ce.vue";
// import SVGCleanLeft from "./components/svg/SVGCleanLeft.ce.vue";
// import SVGCheck from "./components/svg/SVGCheck.ce.vue";
// import SVGDown from "./components/svg/SVGDown.ce.vue";
// import SVGDelete from "./components/svg/SVGDelete.ce.vue";
// import SVGMaskNapkin from "./components/svg/SVGMaskNapkin.ce.vue";

import Loading1 from "./components/loading/Loading1.ce.vue";
import Loading2 from "./components/loading/Loading2.ce.vue";
import Loading3 from "./components/loading/Loading3.ce.vue";
import Loading4 from "./components/loading/Loading4.ce.vue";
import Loading5 from "./components/loading/Loading5.ce.vue";
import Loading6 from "./components/loading/Loading6.ce.vue";
import Loading7 from "./components/loading/Loading7.ce.vue";

import Loading9 from "./components/loading/Loading9.ce.vue";
import Loading10 from "./components/loading/Loading10.ce.vue";
import Loading11 from "./components/loading/Loading11.ce.vue";

import BooleanBox from "./components/form/BooleanBox.ce.vue";
import RadioGroup from "./components/form/RadioGroup.ce.vue";
import CheckboxGroup from "./components/form/CheckboxGroup.ce.vue";
import Switch from "./components/form/Switch.ce.vue";
import Select from "./components/form/Select.ce.vue";
import SelectAbsolute from "./components/form/SelectAbsolute.ce.vue";
import SlideLeftItem from "./components/form/SlideLeftItem.ce.vue";
import Status from "./components/form/Status.ce.vue";

import InputRange from "./components/form/InputRange.ce.vue";
import InputRangeBox from "./components/form/InputRangeBox.ce.vue";
import Tabs from "./components/form/Tabs.ce.vue";

import ProgressBar from "./components/progress/ProgressBar.ce.vue";
import PageVerticalScrollProgressBar from "./components/progress/PageVerticalScrollProgressBar.ce.vue";
import Video from "./components/video/Video.ce.vue";

// import Routes from "./components/base/Routes.ce.vue";
// import RoutesPage from "./components/base/RoutesPage.ce.vue";
import Image from "./components/image/Image.ce.vue";

import Accordion from "./components/form/Accordion.ce.vue";
import MapTianditu from "./components/map/MapTianditu.ce.vue";
import HandWritePanel from "./components/hand/HandWritePanel.ce.vue";

import PlateKeyboard from "./components/keyboard/PlateKeyboard.ce.vue";
import PlateMobile from "./components/plate/PlateMobile.ce.vue";

import NumberKeyboard from "./components/keyboard/NumberKeyboard.ce.vue";

import RingIndicator from "./components/chat/RingIndicator.ce.vue";
import RingText from "./components/chat/RingText.ce.vue";
import ClockFlipper from "./components/clock/ClockFlipper.ce.vue";

import EaseGraphDisplay from "./components/animate/EaseGraphDisplay.ce.vue";
import EaseGroupGraphDisplay from "./components/animate/EaseGroupGraphDisplay.ce.vue";
import InterpolationGraphDisplay from "./components/animate/InterpolationGraphDisplay.ce.vue";
import InterpolationGroupGraphDisplay from "./components/animate/InterpolationGroupGraphDisplay.ce.vue";
import CardFlip from "./components/3d/CardFlip.ce.vue";
import Cube from "./components/3d/Cube.ce.vue";

import Circle from "./components/css/Circle.ce.vue";
import BorderFocusText from "./components/css/BorderFocusText.ce.vue";

import ImageMask from "./components/effect/ImageMask.ce.vue";
import Slide from "./components/effect/Slide.ce.vue";
import SlideCorner from "./components/effect/SlideCorner.ce.vue";
import LineSingle from "./components/effect/LineSingle.ce.vue";
import LineDouble from "./components/effect/LineDouble.ce.vue";
import TextBackgroundClip from "./components/effect/TextBackgroundClip.ce.vue";

// import ChartPie from "./components/ChartPie.ce.vue";
// import Raphael from "./components/Raphael.ce.vue";
// import RaphaelCurve from "./components/RaphaelCurve.ce.vue";
// import RaphaelMetronome from "./components/RaphaelMetronome.ce.vue";
// import RaphaelColorPicker from "./components/RaphaelColorPicker.ce.vue";
// import RaphaelSolarSystem from "./components/RaphaelSolarSystem.ce.vue";

/// original web components
import ResponsiveVideo from "./webcomponents/ResponsiveVideo";

/////////////////////////////////////////////////////

const components = {};

// xxx.ce.vue name is very important !!! 否则不会返回 styles !!!
import Xg from "./Xg.ce.vue";
components["Xg"] = Xg;

// xg
import Lot from "./components/xg/Lot.ce.vue";
components["Lot"] = Lot;
import Footer from "./components/xg/Footer.ce.vue";
components["Footer"] = Footer;
import Park from "./components/xg/Park.ce.vue";
components["Park"] = Park;
import Result from "./components/xg/Result.ce.vue";
components["Result"] = Result;
import Unlocking from "./components/xg/Unlocking.ce.vue";
components["Unlocking"] = Unlocking;
import LoginInPhone from "./components/xg/LoginInPhone.ce.vue";
components["LoginInPhone"] = LoginInPhone;

// view
import ViewDocument from "./components/view/ViewDocument.ce.vue";
components["ViewDocument"] = ViewDocument;

// base
import Root from "./components/base/Root.ce.vue";
components["Root"] = Root;
import Page from "./components/base/Page.ce.vue";
components["Page"] = Page;
import List from "./components/base/List.ce.vue";
components["List"] = List;
import Box from "./components/base/Box.ce.vue";
components["Box"] = Box;
import CSSTransition from "./components/base/CSSTransition.ce.vue";
components["CSSTransition"] = CSSTransition;
import CSSAnimation from "./components/base/CSSAnimation.ce.vue";
components["CSSAnimation"] = CSSAnimation;

// pop
import Overlay from "./components/pop/Overlay.ce.vue";
components["Overlay"] = Overlay;
import Pop from "./components/pop/Pop.ce.vue";
components["Pop"] = Pop;
import PopTel from "./components/pop/PopTel.ce.vue";
components["PopTel"] = PopTel;
import PopCalendar from "./components/pop/PopCalendar.ce.vue";
components["PopCalendar"] = PopCalendar;
import Popover from "./components/pop/Popover.ce.vue";
components["Popover"] = Popover;

// RateXg
import RateXg from "./components/rate-xg/RateXg.ce.vue";
components["RateXg"] = RateXg;
import RateXgPanel from "./components/rate-xg/RateXgPanel.ce.vue";
components["RateXgPanel"] = RateXgPanel;
import RateXgPop from "./components/rate-xg/RateXgPop.ce.vue";
components["RateXgPop"] = RateXgPop;

// dialog
import Dialog from "./components/dialog/Dialog.ce.vue";
components["Dialog"] = Dialog;
import DialogLoading from "./components/dialog/DialogLoading.ce.vue";
components["DialogLoading"] = DialogLoading;
import DialogToast from "./components/dialog/DialogToast.ce.vue";
components["DialogToast"] = DialogToast;

// layout
import LayoutCenter from "./components/layout/LayoutCenter.ce.vue";
components["LayoutCenter"] = LayoutCenter;
import ContentCenter from "./components/layout/ContentCenter.ce.vue";
components["ContentCenter"] = ContentCenter;
import ContentSpaceBetween from "./components/layout/ContentSpaceBetween.ce.vue";
components["ContentSpaceBetween"] = ContentSpaceBetween;
import ContentTopCenter from "./components/layout/ContentTopCenter.ce.vue";
components["ContentTopCenter"] = ContentTopCenter;

// form
import Button from "./components/form/Button.ce.vue";
components["Button"] = Button;
import Text from "./components/form/Text.ce.vue";
components["Text"] = Text;
import Input from "./components/form/Input.ce.vue";
components["Input"] = Input;
import InputFileDrop from "./components/form/InputFileDrop.ce.vue";
components["InputFileDrop"] = InputFileDrop;
import ColorPicker from "./components/form/ColorPicker.ce.vue";
components["ColorPicker"] = ColorPicker;
import Calendar from "./components/form/Calendar.ce.vue";
components["Calendar"] = Calendar;
import Textarea from "./components/form/Textarea.ce.vue";
components["Textarea"] = Textarea;

import BgGrid from "./components/bg/grid/BgGrid.ce.vue";
components["BgGrid"] = BgGrid;

// image
import ImageView from "./components/image/ImageView.ce.vue";
components["ImageView"] = ImageView;

// icon
import IconStatus from "./components/icon/IconStatus.ce.vue";
components["IconStatus"] = IconStatus;
import IconLoading from "./components/icon/IconLoading.ce.vue";
components["IconLoading"] = IconLoading;
import IconWarn from "./components/icon/IconWarn.ce.vue";
components["IconWarn"] = IconWarn;
import IconArrowRight from "./components/icon/IconArrowRight.ce.vue";
components["IconArrowRight"] = IconArrowRight;

// widget
import CallPhone from "./components/widget/CallPhone.ce.vue";
components["CallPhone"] = CallPhone;

// plate
import PlateDisplay from "./components/plate/PlateDisplay.ce.vue";
components["PlateDisplay"] = PlateDisplay;

// fps
import FPSStats from "./components/fps/FPSStats.ce.vue";
components["FPSStats"] = FPSStats;

// success, but not good
// YZCustomElement.linkChildrenComponentsStyles(
//   ["yz-color-picker"],
//   "../lib/dist/ce/style.css"
// );
export function linkChildrenComponentsStyles(
  customElementNames,
  stylePath = "style.css"
) {
  for (let customElementName of customElementNames) {
    const componentShadowDom =
      document.querySelector(customElementName)?.shadowRoot;
    if (componentShadowDom) {
      useLoadLink(stylePath, componentShadowDom);
    }
  }
}

// 过时：不再使用 childComponents 顺序与组件中 customOptions 保持一致
const globalComponentRelation = {};
const globalComponentStyles = {};
export const mergeChildComponentCSS = (
  parentComponent,
  childComponents,
  attatchToShadowRoot = true
) => {
  const parentComponentName = parentComponent.__name;
  globalComponentRelation[parentComponentName] = [];
  let styles = [...(parentComponent.styles || [])];
  let index = 0;
  for (let childComponentName in parentComponent.customOptions) {
    globalComponentRelation[parentComponentName].push(childComponentName);
    // const newScopeId = `[${parentComponent.customOptions[childComponentName].__scopeId}]`;
    styles = [
      ...(globalComponentRelation[childComponentName] || []).reduce(
        (acc, name) => {
          acc.push(
            ...(globalComponentStyles[name] || []).map((style) =>
              // trimScopedCSS(style, newScopeId)
              trimScopedCSS(style)
            )
          );
          return acc;
        },
        []
      ),
      ...(childComponents[index++]?.styles || []).map((style) =>
        // trimScopedCSS(style, newScopeId)
        trimScopedCSS(style)
      ),
      ...styles
    ];
    globalComponentStyles[childComponentName] = styles;
  }
  if (!attatchToShadowRoot) {
    // if use Teleport
    for (let styleContent of parentComponent.styles) {
      const styleEl = document.createElement("style");
      styleEl.innerHTML = styleContent;
      document.head.insertBefore(
        styleEl,
        document.head.childNodes[document.head.childNodes.length - 1]
          .nextSibling
      );
    }
  } else {
    parentComponent.styles = styles;
  }
  globalComponentStyles[parentComponentName] = styles;
  return parentComponent;
};

// 在用版本: 在组件中定义 customOptions = 有style的直接子代，间接后代不用写
// self = {
//   customOptions: { childComponent : 递归self },
//   inheritAttrs: true,
//   props: {clickedCoverColor: {default:'#000000'}}
//   setup: Fn,
//   __name: "Page",
//   __scopeId: "data-v-e9f31eef"
// }
// self.customOptions 中的引入的组件是 X.vue 没有 styles ！: { 0: ".lot-main-bg[data-v-a461f1a6]{position:absolute;}"}
export const collectChildComponentCSS = (
  self,
  isChild = false,
  collected = [], // child component names
  commonScopeId = ""
) => {
  const styles = [];
  if (!self.__name) {
    return styles;
  }
  // X.ce
  const selfName = self.__name.split(".")?.[0] || "";
  if (!isChild) {
    commonScopeId = self.__scopeId || "";
  }
  // 自己的 styles 会被自动注入！
  if (!isInArray(collected, selfName) && isChild) {
    styles.push(
      ...(self.styles || []).map((s) => {
        // if (commonScopeId) {
        //   return trimScopedCSS(s, `[${commonScopeId}]`);
        // } else {
        return trimScopedCSS(s);
        // }
      })
    );
    collected.push(selfName);
  }
  if (!self.customOptions) {
    return styles;
  }
  for (let childComponentName in self.customOptions) {
    const child = components[childComponentName];
    if (!child) {
      continue;
    }
    const childName = child.__name.split(".")?.[0] || "";
    // 避免死循环
    if (childName == selfName) {
      continue;
    }
    // 递归调用
    styles.push(
      ...collectChildComponentCSS(child, true, collected, commonScopeId)
    );
  }
  return styles;
};

function YZDefineCustomElement(
  component,
  { plugins = [] } = {
    plugins: [router]
  }
) {
  return defineCustomElement({
    // render: () => h(component),
    ...component, // <-- use all props from the original component (except setup)
    // styles: component.styles,
    exposed: component.exposed,
    setup(props, { attrs, slots, emit, expose }) {
      const app = createApp();
      plugins.forEach(app.use);
      const vm = getCurrentInstance();
      Object.assign(vm.appContext, app._context);
      Object.assign(vm.provides, app._context.provides);
      // app.mixin({
      //   mounted() {
      //     this.__style = document.createElement("style");
      //     this.__style.innerText = collectChildComponentCSS(component)
      //       .join("")
      //       .replace(/\n/g, "");
      //     nearestElement(this.$el)?.prepend(this.__style);
      //     // console.log(vm, this, component);
      //   },
      //   unmounted() {
      //     this.__style?.remove();
      //   }
      // });
      const __style = document.createElement("style");
      __style.innerText = collectChildComponentCSS(component)
        .join("")
        .replace(/\n/g, "");
      const shadowRoot = useShadowRoot();
      shadowRoot.appendChild(__style);
      return component.setup?.(props, { attrs, slots, emit, expose }); // <-- run initial setup if exists
    }
  });
}

export const install = () => {
  customElements.define(
    "yz-effect-css-transition",
    YZDefineCustomElement(CSSTransition)
  );
  customElements.define(
    "yz-effect-css-animation",
    YZDefineCustomElement(CSSAnimation)
  );

  customElements.define("yz-icon", YZDefineCustomElement(Icon));

  customElements.define("yz-loading-1", YZDefineCustomElement(Loading1));
  customElements.define("yz-loading-2", YZDefineCustomElement(Loading2));
  customElements.define("yz-loading-3", YZDefineCustomElement(Loading3));
  customElements.define("yz-loading-4", YZDefineCustomElement(Loading4));
  customElements.define("yz-loading-5", YZDefineCustomElement(Loading5));
  customElements.define("yz-loading-6", YZDefineCustomElement(Loading6));
  customElements.define("yz-loading-7", YZDefineCustomElement(Loading7));
  customElements.define("yz-loading-8", YZDefineCustomElement(IconLoading));
  customElements.define("yz-loading-9", YZDefineCustomElement(Loading9));
  customElements.define("yz-loading-10", YZDefineCustomElement(Loading10));
  customElements.define("yz-loading-11", YZDefineCustomElement(Loading11));

  customElements.define("yz-button", YZDefineCustomElement(Button));
  customElements.define("yz-boolean-box", YZDefineCustomElement(BooleanBox));
  customElements.define("yz-radio-group", YZDefineCustomElement(RadioGroup));
  customElements.define(
    "yz-checkbox-group",
    YZDefineCustomElement(CheckboxGroup)
  );
  customElements.define("yz-switch", YZDefineCustomElement(Switch));
  customElements.define("yz-select", YZDefineCustomElement(Select));
  customElements.define(
    "yz-select-absolute",
    YZDefineCustomElement(SelectAbsolute)
  );
  customElements.define(
    "yz-slide-left-item",
    YZDefineCustomElement(SlideLeftItem)
  );
  customElements.define("yz-status", YZDefineCustomElement(Status));

  customElements.define("yz-input", YZDefineCustomElement(Input));
  customElements.define("yz-input-range", YZDefineCustomElement(InputRange));
  customElements.define(
    "yz-input-range-box",
    YZDefineCustomElement(InputRangeBox)
  );
  customElements.define(
    "yz-input-file-drop",
    YZDefineCustomElement(InputFileDrop)
  );

  customElements.define("yz-textarea", YZDefineCustomElement(Textarea));

  customElements.define("yz-bg-grid", YZDefineCustomElement(BgGrid));

  customElements.define("yz-tabs", YZDefineCustomElement(Tabs));

  customElements.define("yz-progress-bar", YZDefineCustomElement(ProgressBar));
  customElements.define(
    "yz-page-vertical-scroll-progress-bar",
    YZDefineCustomElement(PageVerticalScrollProgressBar)
  );
  customElements.define("yz-video", YZDefineCustomElement(Video));

  customElements.define("yz-pop", YZDefineCustomElement(Pop));
  customElements.define("yz-pop-tel", YZDefineCustomElement(PopTel));
  customElements.define("yz-pop-calendar", YZDefineCustomElement(PopCalendar));
  customElements.define("yz-popover", YZDefineCustomElement(Popover));
  customElements.define("yz-color-picker", YZDefineCustomElement(ColorPicker));
  customElements.define("yz-pop-rate-xg", YZDefineCustomElement(RateXgPop));

  customElements.define("yz-dialog", YZDefineCustomElement(Dialog));
  customElements.define(
    "yz-dialog-loading",
    YZDefineCustomElement(DialogLoading)
  );
  customElements.define("yz-dialog-toast", YZDefineCustomElement(DialogToast));

  // mergeChildComponentCSS(RoutesPage, [CSSAnimation]);
  // customElements.define("yz-page", defineCustomElement(RoutesPage));
  // mergeChildComponentCSS(Routes, [RoutesPage]);
  // customElements.define("yz-routes", defineCustomElement(Routes));
  customElements.define("yz-image", YZDefineCustomElement(Image));
  customElements.define("yz-image-view", YZDefineCustomElement(ImageView));

  customElements.define("yz-accordion", YZDefineCustomElement(Accordion));
  customElements.define(
    "yz-resize-observer",
    YZDefineCustomElement(ResizeObserver)
  );
  customElements.define("yz-map-tianditu", YZDefineCustomElement(MapTianditu));
  customElements.define(
    "yz-hand-write-panel",
    YZDefineCustomElement(HandWritePanel)
  );

  customElements.define(
    "yz-plate-keyboard",
    YZDefineCustomElement(PlateKeyboard)
  );
  customElements.define("yz-plate-mobile", YZDefineCustomElement(PlateMobile));
  customElements.define(
    "yz-plate-display",
    YZDefineCustomElement(PlateDisplay)
  );

  customElements.define(
    "yz-number-keyboard",
    YZDefineCustomElement(NumberKeyboard)
  );

  customElements.define(
    "yz-chat-ring-indicator",
    YZDefineCustomElement(RingIndicator)
  );
  customElements.define("yz-chat-ring-text", YZDefineCustomElement(RingText));
  customElements.define(
    "yz-chat-clock-flipper",
    YZDefineCustomElement(ClockFlipper)
  );

  customElements.define("yz-fps-stats", YZDefineCustomElement(FPSStats));
  customElements.define(
    "yz-ease-graph-display",
    YZDefineCustomElement(EaseGraphDisplay)
  );
  customElements.define(
    "yz-ease-group-graph-display",
    YZDefineCustomElement(EaseGroupGraphDisplay)
  );
  customElements.define(
    "yz-interpolation-graph-display",
    YZDefineCustomElement(InterpolationGraphDisplay)
  );
  customElements.define(
    "yz-interpolation-group-graph-display",
    YZDefineCustomElement(InterpolationGroupGraphDisplay)
  );
  customElements.define("yz-card-flip", YZDefineCustomElement(CardFlip));
  customElements.define("yz-cube", YZDefineCustomElement(Cube));

  customElements.define(
    "yz-effect-image-mask",
    YZDefineCustomElement(ImageMask)
  );
  customElements.define("yz-effect-slide", YZDefineCustomElement(Slide));
  customElements.define(
    "yz-effect-slide-corner",
    YZDefineCustomElement(SlideCorner)
  );
  customElements.define(
    "yz-effect-line-single",
    YZDefineCustomElement(LineSingle)
  );
  customElements.define(
    "yz-effect-line-double",
    YZDefineCustomElement(LineDouble)
  );
  customElements.define("yz-effect-circle", YZDefineCustomElement(Circle));
  customElements.define(
    "yz-effect-text-background-clip",
    YZDefineCustomElement(TextBackgroundClip)
  );
  customElements.define(
    "yz-effect-border-focus-text",
    YZDefineCustomElement(BorderFocusText)
  );

  customElements.define("yz-xg", YZDefineCustomElement(Xg));

  // customElements.define("yz-chart-pie", YZDefineCustomElement(ChartPie));
  // customElements.define("yz-raphael", YZDefineCustomElement(Raphael));
  // customElements.define("yz-raphael-curve", YZDefineCustomElement(RaphaelCurve));
  // customElements.define("yz-raphael-metronome", YZDefineCustomElement(RaphaelMetronome));
  // customElements.define("yz-raphael-color-picker", YZDefineCustomElement(RaphaelColorPicker));
  // customElements.define("yz-raphael-solar-system", YZDefineCustomElement(RaphaelSolarSystem));

  ////////////////////////////// original web components //////////////////////////////
  customElements.define("yz-responsive-video", ResponsiveVideo);

  ////////////////////////////// 可选 //////////////////////////////

  ////////////////////////////// Inject Global Component //////////////////////////////
  // const globalDialogToast = document.createElement("yz-dialog-toast");
  // globalDialogToast.id = "globalDialogToast";
  // teleport.appendChild(globalDialogToast);

  // const globalDialogLoading = document.createElement("yz-dialog-loading");
  // globalDialogLoading.id = "globalDialogLoading";
  // teleport.appendChild(globalDialogLoading);

  // const globalDialog = document.createElement("yz-dialog");
  // globalDialog.id = "globalDialog";
  // teleport.appendChild(globalDialog);

  // const globalPlateKeyboard = document.createElement("yz-plate-keyboard");
  // globalPlateKeyboard.id = "globalPlateKeyboard";
  // teleport.appendChild(globalPlateKeyboard);

  // const globalNumberKeyboard = document.createElement("yz-number-keyboard");
  // globalNumberKeyboard.id = "globalNumberKeyboard";
  // teleport.appendChild(globalNumberKeyboard);
};
